import { React, useEffect, useState } from 'react';

// mui
import { Dialog, Box } from '@mui/material';

// components
import { PostShowMediaHeader, PostShowMediaBottom, PostShowMediaPlay, PostShowMediaOverlay, PostComment } from '..';

// client-shared
import { storage } from '@goldblack/client-storage';
import { scrollbarSx } from '@goldblack/client-comps';
import { def } from '@goldblack/shared';

function PostView(props) {
    const [openComment, setOpenComment] = useState(false);
    const [reportedStatus, setReportedStatus] = useState(null);

    const postStatus = reportedStatus ?? props.post?.status;

    const onClickComment = () => {
        setOpenComment(!openComment);
    };

    useEffect(() => {
        if (props.openComment) {
            setOpenComment(true);
        }
        storage.transience.setState('internal.dialog', true);
        return () => {
            storage.transience.setState('internal.dialog', false);
            setOpenComment(false);
        };
    }, []);

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            maxWidth='xs'
            fullWidth
            slotProps={{
                paper: {
                    elevation: 0,
                    variant: 'outlined',
                    sx: scrollbarSx,
                },
            }}>
            {props.post && (
                <>
                    <Box sx={{ position: 'relative' }}>
                        <PostShowMediaPlay
                            {...props}
                            dialog={true}
                            blurred={
                                postStatus === def.PostStatus.BLOCKED ||
                                postStatus === def.PostStatus.CENSORED ||
                                postStatus === def.PostStatus.PROCESSING
                            }
                            showThumbnail={
                                postStatus === def.PostStatus.PROCESSING || postStatus === def.PostStatus.CENSORED
                            }
                        />
                        <PostShowMediaHeader
                            {...props}
                            post={{ ...props.post, status: postStatus }}
                            onReport={() => {
                                setReportedStatus(def.PostStatus.PROCESSING);
                                props.onReport?.();
                            }}
                        />
                        <PostShowMediaBottom
                            {...props}
                            post={{ ...props.post, status: postStatus }}
                            onClickComment={onClickComment}
                        />
                        {(postStatus === def.PostStatus.BLOCKED ||
                            postStatus === def.PostStatus.CENSORED ||
                            postStatus === def.PostStatus.PROCESSING) &&
                            PostShowMediaOverlay({ ...props.post, status: postStatus }, true, props.onClose)}
                    </Box>
                    <PostComment {...props} open={openComment} />
                </>
            )}
        </Dialog>
    );
}

export { PostView };
